import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { CalendarSetupFileHistoryComponent } from "./calendar-setup-file-history/calendar-setup-file-history.component";

const routes: Routes = [
	{
		path: "files",
		component: CalendarSetupFileHistoryComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class CalendarSetupFileHistoryRoutingModule {}
